import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { RouterModule } from '@angular/router';
import { MenuItem } from 'primeng/api';
import { PanelMenuModule } from 'primeng/panelmenu';
import { AppMenuService } from '../service/menu.service';
import { AppMenuitem } from './app.menuitem';

@Component({
  selector: 'app-menu',
  standalone: true,
  imports: [CommonModule, AppMenuitem, RouterModule, PanelMenuModule],
  templateUrl: './app.menu.html',
})
export class AppMenu {
  @Input() model: MenuItem[] = [];

  private readonly appMenuService = inject(AppMenuService);

  ngOnInit() {
    const permisos = this.appMenuService.getMenu();
    this.model = this.appMenuService.getMenuItems();
  }
}
